import React, { Suspense } from 'react';
import { Route, Routes as ReactRouterRoutes } from 'react-router-dom';

import routes from 'routes/routes';

export default function Router() {
    return (
        <ReactRouterRoutes>
            {routes.map((route) => {
                return (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={
                            <Suspense fallback={<div>Loading...</div>}>
                                {route.element}
                            </Suspense>
                        }
                    />
                );
            })}
        </ReactRouterRoutes>
    );
}
